import { BusybeesTheme as BusybeesMFTheme } from '@famly/mf_theme';
import BaseTheme from './base';
const BusybeesTheme = {
    ...BaseTheme,
    title: 'Busybees',
    chromeColor: BusybeesMFTheme.colorPalette.brandColor,
    mf: BusybeesMFTheme,
};
export default BusybeesTheme;
